"use strict"

import React, { useRef } from "react"
import { Button, Modal } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import PropTypes from "prop-types"

import UploadData from "../../../widgets/UploadData"
import LoaderGif from "../../../widgets/LoaderGif"

export default function ModalUploadProcurementItems(props) {
  const loaderRef = useRef()
  const uploadRef = useRef()

  return (
    <Modal show={props.show} onHide={props.onHide} backdrop={"static"} keyboard={true}>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className={"fa fa-arrow-circle-o-up"} />
          &nbsp;&nbsp;
          <FormattedMessage id={"inventory.procurement"} /> - <FormattedMessage id={"general.upload.csv"} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div align={"center"}>
          <FormattedMessage id={"stock.file.upload.description"} description={`File Upload Description`} />
        </div>

        <LoaderGif loaderRef={loaderRef} />
        <div ref={uploadRef}>
          <div align={"center"} style={{ padding: "10px" }}>
            <a
              href={"/static/examples/template-inventory-procurement.csv"}
              target={"_blank"}
              className={"btn btn-sm link_btn_outline_primary"}
            >
              <span className={"fa fa-file-o"} />
              &nbsp;&nbsp;
              <FormattedMessage id={"general.download.template"} />
            </a>
          </div>

          <UploadData
            file_type={"Laboratory Inventory Loader"}
            process_now={true}
            metadata={{}}
            submit_file={() => {
              loaderRef.current ? (loaderRef.current["style"].display = `block`) : null
              uploadRef.current ? (uploadRef.current["style"].visibility = `hidden`) : null
            }}
            refresh_data={() => {
              loaderRef.current ? (loaderRef.current["style"].display = `none`) : null
              uploadRef.current ? (uploadRef.current["style"].visibility = `visible`) : null
              props.onSuccess()
            }}
            on_upload_fail={() => {
              loaderRef.current ? (loaderRef.current["style"].display = `none`) : null
              uploadRef.current ? (uploadRef.current["style"].visibility = `visible`) : null
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant={"outline-primary"} onClick={props.onHide} style={{ display: "flex", float: "left" }}>
          <FormattedMessage id={"general.closeButton"} description={"Close Button For Stock Upload"} />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

ModalUploadProcurementItems.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
}
